import { TextInput, TextInputProps } from '@mantine/core';

import { IconInfoCircle } from '@tabler/icons-react';

import IconSearch from '../../../assets/icons/IconSearch.svg?react';
import { HoverPopover } from '../../popovers';

type SearchInputType = {
	helpText?: string;
} & TextInputProps;

export const SearchInput = ({ helpText, ...rest }: SearchInputType) => {
	return (
		<TextInput
			leftSection={<IconSearch width={20} />}
			size="md"
			{...(helpText
				? {
						rightSection: (
							<HoverPopover position="bottom-end" text={helpText} withArrow>
								<IconInfoCircle width={20} />
							</HoverPopover>
						),
					}
				: {})}
			{...rest}
		/>
	);
};
